import { BlogCategoryEnum, BlogTypeEnum } from "./category";

export const PCPS_RESEARCH_DATA = [
    {
        title: "How Agentic AI Is Transforming Digital Business Models",
        featured: true,
        href: `/how-agentic-ai-is-transforming-digital-business-models`,
        image: `/pcps-research/how-agentic-ai-is-transforming-digital-business-models/agentic-ai.png`,
        landingImage: `/pcps-research/how-agentic-ai-is-transforming-digital-business-models/agentic-ai-landing.png`,
        category: BlogCategoryEnum.ArtificialIntelligence,
        author: "Ashika Shrestha",
        type: BlogTypeEnum.ARTICLE,
        // date: "22 january 2026"
        date: "2026-01-22",
    },
    {
        title: "Predictive Analytics: Forecasting Growth for Nepal’s Small Businesses",
        image: `/pcps-research/analytics.jpg`,
        href: `/predictive-analytics-forecasting-growth-for-nepals-small-businesses`,
        landingImage: `/pcps-research/predictive-analytics-forecasting-growth-for-nepals-small-businesses/analytics-landing.jpg`,
        category: BlogCategoryEnum.Data,
        author: "Samikshya Gautam",
        type: BlogTypeEnum.ARTICLE,
        // date: "Jan 22, 2026"
        date: "2026-01-22"
    },
    {
        title: "Why is Zero Code / Low Code App Development getting popular?",
        image: "/pcps-research/zero-coding.png",
        landingImage: "/pcps-research/zero-coding-banner.png",
        href: "/why-is-zero-code-low-code-app-development-getting-popular",
        category: BlogCategoryEnum.SoftwareDevelopment,
        author: "Arun Sagar Rai",
        type: BlogTypeEnum.RESEARCH,
        date: "2026-02-05"
    },
    {
    title: "Top 10 IT Colleges in Nepal (2026): Best International Degree Options, Fees & How to Choose",
    image: `/pcps-research/top-10-it-colleges-in-nepal/hero.png`,
    href: `/top-10-it-colleges-in-nepal-2026`,
    landingImage: `/pcps-research/top-10-it-colleges-in-nepal/hero.png`,
    category: BlogCategoryEnum.NepalMarket,
    author: "Kaushal Kunwar",
    type: BlogTypeEnum.ARTICLE,
    date: "2026-07-21"
    },
    {
        title: "AI Risks in 2026: The 12 Dangers of Artificial Intelligence Explained",
        featured: false,
        href: `/ai-risks`,
        image: `/pcps-research/ai-risks/image.png`,
        landingImage: `/pcps-research/ai-risks/landing.png`,
        category: BlogCategoryEnum.ArtificialIntelligence,
        author: "Milan Basnet",
        type: BlogTypeEnum.ARTICLE,
        date: "2026-07-24"
    },
]